import styled from '@emotion/styled';

export const Space = styled.div<{ height?: number; width?: number }>`
  height: ${({ height = 20 }) => height}px;
  width: ${({ width = 20 }) => width}px;
`;
